import { AxiosResponse } from "axios";
import {
  GenerateInventoryReportRequest,
  GenerateInventoryReportResponse,
  InventoryReportRequestsResponse,
  InventoryReportStatusResponse,
} from "../../@types/DRO/InventoryHistoryReport";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class InventoryHistoryReportApi {
  public static api = new InventoryHistoryReportApi();
  private instance = erpAxios;

  async generateReport(
    request: GenerateInventoryReportRequest
  ): Promise<GenerateInventoryReportResponse> {
    const response: AxiosResponse<GenerateInventoryReportResponse> =
      await this.instance.post(
        "/erp/api/v1/inventory/stock-report/generate",
        undefined,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
            Accept: "application/json",
          },
          params: {
            date: request.date,
            warehouseIds: request.warehouseIds?.join(","),
          },
        }
      );

    return response.data;
  }

  async getReportStatus(
    reportId: number
  ): Promise<InventoryReportStatusResponse> {
    const response: AxiosResponse<InventoryReportStatusResponse> =
      await this.instance.get(
        `/erp/api/v1/parts/inventory/stock-report/status/${reportId}`,
        {
          headers: {
            Authorization: `Bearer ${getAuthToken()}`,
          },
        }
      );

    return response.data;
  }

  async getReportRequests(
    page = 0,
    size = 10
  ): Promise<InventoryReportRequestsResponse> {
    const response: AxiosResponse<InventoryReportRequestsResponse> =
      await this.instance.get("/erp/api/v1/inventory/stock-report/requests", {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
        params: { page, size },
      });

    return response.data;
  }
}
